<!-- Normal Payment Sayfası -->
<section class="layout-pt-md layout-pb-lg">
  <div class="container">

    <!-- 3D Secure Bilgilendirme -->
    <div *ngIf="isProcessingPayment" class="secure-loading-box">
      <div class="secure-loading-content">
        <div class="secure-spinner"></div>
        <div class="secure-text">
          <div class="secure-title">🔒 3D Secure Doğrulaması</div>
          <div class="secure-desc">Banka doğrulamasını tamamlayın, otomatik yönlendirileceksiniz.</div>
        </div>
      </div>
    </div>

    <div class="row">

      <!-- Sol Sütun: Kampanyalar ve Ödeme Seçenekleri -->
      <div class="col-lg-6">
        <div class="bg-white rounded-4 border-light shadow-1 p-30">
          <!-- Ödeme Seçenekleri -->
          <div>
            <h4 class="text-20 fw-600 text-dark-1 mb-10">Ödeme Seçenekleri</h4>

            <!-- Kısmi Ödeme Seçenekleri -->
            <div class="mb-30" *ngIf="transactionSummary?.data?.isPayablePartail">
              <div class="border-1 border-blue-1 rounded-4 p-20 bg-blue-1-05 mb-20">
                <div class="d-flex items-center mb-15">
                  <i class="icon-info text-20 text-blue-1 mr-10"></i>
                  <div class="text-16 fw-600 text-blue-1">Kısmi Ödeme Seçeneği</div>
                </div>
                <p class="text-14 text-light-1 mb-15">
                  Minimum {{ transactionSummary?.data?.basketLeastwiseAmount?.value |
                  currency:'TRY':'symbol':'1.0-0':'tr' }}
                  ödeme yaparak rezervasyonunuzu garantileyebilirsiniz. Kalan tutarı otelde ödeyebilirsiniz.
                </p>

                <div class="row y-gap-15">
                  <div class="col-md-6">
                    <div class="border-1 border-light rounded-4 p-15 cursor-pointer payment-option"
                      [class.selected]="paymentType === 'partial'" (click)="selectPaymentType('partial')">
                      <div class="text-center">
                        <div class="text-16 fw-600 text-dark-1 mb-5">Kısmi Ödeme</div>
                        <div class="text-14 text-light-1 mb-10">{{
                          transactionSummary?.data?.basketLeastwiseAmount?.value | currency:'TRY':'symbol':'1.0-0':'tr'
                          }}</div>
                        <div class="text-12 text-green-1">Rezervasyon Garantili</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="border-1 border-light rounded-4 p-15 cursor-pointer payment-option"
                      [class.selected]="paymentType === 'full'" (click)="selectPaymentType('full')">
                      <div class="text-center">
                        <div class="text-16 fw-600 text-dark-1 mb-5">Tam Ödeme</div>
                        <div class="text-14 text-light-1 mb-10">{{ transactionSummary?.data?.balance?.value |
                          currency:'TRY':'symbol':'1.0-0':'tr' }}</div>
                        <div class="text-12 text-blue-1">Hemen Tamamla</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="text-16 fw-500 text-dark-1 mb-20">Banka/Kredi Kartı ile Öde</h5>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="soft-alert mb-20">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <span>{{ errorMessage }}</span>
            </div>
            <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">

              <!-- Kart Numarası -->
              <div class="form-group mb-20">
                <label class="form-label">Kart Numarası*</label>
                <input type="text" formControlName="cardNumber" class="form-control"
                  maxlength="19" autocomplete="off" name="no-autofill-pusula-xyz"
                  data-lpignore="true" data-form-type="other">
              </div>

              <!-- Kart Sahibinin Adı -->
              <div class="form-group mb-20">
                <label class="form-label">Kart Sahibinin Adı ve Soyadı*</label>
                <input type="text" formControlName="cardHolderName" class="form-control"
                  placeholder="Kartın ön yüzündeki ad ve soyadı giriniz">
              </div>

              <!-- Son Kullanma Tarihi -->
              <div class="row y-gap-20 mb-20">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Ay*</label>
                    <select formControlName="expiryMonth" class="form-control">
                      <option value="">Ay Seçiniz</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Yıl*</label>
                    <select formControlName="expiryYear" class="form-control">
                      <option value="">Yıl Seçiniz</option>
                      <option *ngFor="let y of expiryYears" [value]="y.value">{{ y.label }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Güvenlik Kodu -->
              <div class="form-group mb-20">
                <label class="form-label">Güvenlik Kodu*</label>
                <div class="d-flex items-center">
                  <input type="text" formControlName="cvv" (input)="formatCVV($event)" class="form-control"
                    placeholder="CVV" maxlength="4">
                  <div class="ml-10">
                    <i class="icon-info text-20 text-blue-1"></i>
                  </div>
                </div>
              </div>

              <!-- İzole taksit seçici — OnPush + signals, payment sayfasının CD'siyle bağımsız -->
              <app-installment-selector
                [control]="paymentForm.get('cardNumber')"
                [maxInstallment]="maxInstallment"
                [totalPrice]="getPaymentAmount()"
                [initialCount]="selectedInstallmentCount"
                (installmentSelected)="selectedInstallmentCount = $event">
              </app-installment-selector>

              <button type="submit" class="button h-50 px-60 text-white bg-blue-1 w-100"
                [disabled]="isProcessingPayment || isLoading || !paymentForm.valid"
                [style.opacity]="isProcessingPayment || isLoading || !paymentForm.valid ? '0.6' : '1'"
                [style.cursor]="isProcessingPayment || isLoading || !paymentForm.valid ? 'not-allowed' : 'pointer'">
                <span *ngIf="!isProcessingPayment && !isLoading">ÖDEME YAP</span>
                <span *ngIf="isProcessingPayment || isLoading" class="d-flex items-center justify-center">
                  <span class="spinner-border spinner-border-sm mr-10" role="status"></span>
                  İŞLENİYOR...
                </span>
              </button>

            </form>
          </div>
        </div>
      </div>

      <!-- Sağ Sütun: Rezervasyon Detayları -->
      <div class="col-lg-6">
        <div class="bg-white rounded-4 border-light shadow-1 p-30">

          <!-- Rezervasyon Detayları -->
          <h4 class="text-20 fw-600 text-dark-1 mb-20">Rezervasyon Detayları</h4>

          <!-- Otel Bilgileri -->
          <div class="border-1 border-light rounded-4 p-20 mb-20" *ngIf="selectedHotel">
            <div class="d-flex items-center mb-15">
              <img [src]="selectedHotel.image" [alt]="selectedHotel.name" class="size-60 rounded-4 object-cover mr-15">
              <div>
                <h5 class="text-16 fw-600 text-dark-1 mb-5">{{ selectedHotel.name }}</h5>
                <div class="text-14 text-light-1">{{ selectedHotel.location }}</div>
              </div>
            </div>

            <!-- Giriş/Çıkış Tarihleri -->
            <div class="row y-gap-10 mb-15">
              <div class="col-6">
                <div class="text-14 text-light-1">Giriş Tarihi</div>
                <div class="text-14 fw-500 text-dark-1">
                  {{ selectedHotel.checkIn | date:'dd MMM yyyy E' }}
                </div>
                <div class="text-12 text-light-1" *ngIf="selectedHotel.checkInTime">
                  <i class="icon-clock text-10 mr-5"></i>Saat: {{ selectedHotel.checkInTime }}
                </div>
              </div>
              <div class="col-6">
                <div class="text-14 text-light-1">Çıkış Tarihi</div>
                <div class="text-14 fw-500 text-dark-1">
                  {{ selectedHotel.checkOut | date:'dd MMM yyyy E' }}
                </div>
                <div class="text-12 text-light-1" *ngIf="selectedHotel.checkOutTime">
                  <i class="icon-clock text-10 mr-5"></i>Saat: {{ selectedHotel.checkOutTime }}
                </div>
              </div>
            </div>

            <!-- Oda Detayları -->
            <div class="row y-gap-10">
              <div class="col-12">
                <div class="text-14 text-light-1">Oda</div>
                <div class="text-14 fw-500 text-dark-1">{{ selectedHotel.roomType }}</div>
              </div>
              <div class="col-12">
                <div class="text-14 text-light-1">Misafir</div>
                <div class="text-14 fw-500 text-dark-1">{{ passengerData?.passengers?.length || 1 }} Yetişkin</div>
              </div>
              <div class="col-12">
                <div class="text-14 text-light-1">Yemek</div>
                <div class="text-14 fw-500 text-dark-1">{{ selectedHotel.mealType }}</div>
              </div>
              <div class="col-12">
                <div class="d-flex items-center">
                  <div class="text-14 fw-500 text-dark-1">İptal Politikası</div>
                  <i class="icon-info text-16 text-light-1 ml-5"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- ========== EK HİZMETLER BÖLÜMÜ ========== -->
          <div class="border-1 border-light rounded-4 p-20 mb-20 addons-section" *ngIf="availableAddons.length > 0">
            <!-- Başlık -->
            <div class="d-flex items-center justify-between cursor-pointer" (click)="toggleAddonsSection()">
              <div class="d-flex items-center">
                <i class="icon-star text-20 text-blue-1 mr-10"></i>
                <h4 class="text-18 fw-600 text-dark-1">Ek Hizmetler</h4>
                <span class="ml-10 text-14 text-light-1" *ngIf="selectedAddonCount > 0">
                  ({{ selectedAddonCount }} seçili)
                </span>
              </div>
              <i class="icon-chevron-down text-16 transition-transform" 
                 [class.rotate-180]="showAddonsSection"></i>
            </div>

            <!-- Açıklama -->
            <p class="text-14 text-light-1 mt-10 mb-15">
              Konaklamanızı daha özel hale getirin. Transfer, spa, özel kutlama paketi ve daha fazlası.
            </p>

            <!-- Addon Listesi -->
            <div class="y-gap-15" *ngIf="showAddonsSection">
              <div *ngFor="let addon of availableAddons" 
                   class="addon-item border-1 border-light rounded-4 p-15 transition-all"
                   [class.addon-selected]="isAddonSelected(addon.key)"
                   [class.addon-required]="addon.isRequired"
                   [class.addon-loading]="isAddonInProgress(addon.key)">
                
                <div class="d-flex items-start justify-between">
                  <!-- Sol: Checkbox ve Bilgi -->
                  <div class="d-flex items-start flex-grow-1">
                    <!-- Toggle Switch -->
                    <label class="addon-toggle mr-15">
                      <input type="checkbox" 
                             [checked]="isAddonSelected(addon.key)"
                             [disabled]="addon.isRequired || isAddonInProgress(addon.key)"
                             (change)="toggleAddon(addon, $event)">
                      <span class="addon-toggle-slider" 
                            [class.addon-toggle-disabled]="addon.isRequired"></span>
                    </label>

                    <!-- Addon Bilgileri -->
                    <div class="addon-info flex-grow-1">
                      <div class="d-flex items-center">
                        <span class="text-15 fw-500 text-dark-1">{{ addon.name }}</span>
                        
                        <!-- Loading Spinner -->
                        <div *ngIf="isAddonInProgress(addon.key)" 
                             class="addon-spinner ml-10"></div>
                        
                        <!-- Zorunlu Badge -->
                        <span *ngIf="addon.isRequired" 
                              class="addon-badge addon-badge-required ml-10">
                          Zorunlu
                        </span>
                        
                        <!-- Ücretsiz Badge -->
                        <span *ngIf="!addon.isRequired && (!addon.price || addon.price.value === 0)" 
                              class="addon-badge addon-badge-free ml-10">
                          Ücretsiz
                        </span>
                      </div>

                      <!-- Açıklama -->
                      <p class="text-13 text-light-1 mt-5" *ngIf="addon.description">
                        {{ addon.description }}
                      </p>

                      <!-- Kişi başı bilgisi -->
                      <div class="text-12 text-light-1 mt-5" *ngIf="addon.perPerson">
                        <i class="icon-user text-10 mr-5"></i>
                        Kişi başı ücretlendirilir
                      </div>
                    </div>
                  </div>

                  <!-- Sağ: Fiyat -->
                  <div class="addon-price text-right ml-15">
                    <div class="text-15 fw-600" 
                         [class.text-green-1]="!addon.price || addon.price.value === 0"
                         [class.text-dark-1]="addon.price && addon.price.value > 0">
                      {{ getAddonPriceText(addon) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Seçili Addon Özeti -->
              <div class="addon-summary mt-20 pt-15 border-top-light" 
                   *ngIf="selectedAddonCount > 0">
                <div class="d-flex items-center justify-between">
                  <span class="text-14 text-dark-1">Ek hizmetler toplamı:</span>
                  <span class="text-16 fw-600 text-blue-1">
                    +{{ optionalAddonTotalPrice | currency:'TRY':'symbol':'1.0-0':'tr' }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Kapalıyken Özet -->
            <div *ngIf="!showAddonsSection && selectedAddonCount > 0" 
                 class="mt-10 pt-10 border-top-light">
              <div class="d-flex items-center justify-between text-14">
                <span class="text-light-1">{{ selectedAddonCount }} ek hizmet seçili</span>
                <span class="text-blue-1 fw-500">
                  +{{ optionalAddonTotalPrice | currency:'TRY':'symbol':'1.0-0':'tr' }}
                </span>
              </div>
            </div>
          </div>

          <!-- ========== TOPLAM FİYAT ÖZETİ ========== -->
          <!-- Toplam Fiyat Özeti -->
          <div class="border-1 border-light rounded-4 p-20 mb-20" *ngIf="transactionSummary?.data">
            <!-- Oda Fiyatı -->
            <div class="d-flex items-center justify-between mb-10">
              <div class="text-14 text-light-1">Oda Fiyatı</div>
              <div class="text-14 fw-500 text-dark-1">
                {{ selectedHotel?.price | currency:'TRY':'symbol':'1.0-0':'tr' }}
              </div>
            </div>

            <!-- Ek Hizmetler (varsa) -->
            <div class="d-flex items-center justify-between mb-10" *ngIf="optionalAddonTotalPrice > 0">
              <div class="text-14 text-light-1">
                Ek Hizmetler ({{ selectedAddonCount }})
              </div>
              <div class="text-14 fw-500 text-blue-1">
                +{{ optionalAddonTotalPrice | currency:'TRY':'symbol':'1.0-0':'tr' }}
              </div>
            </div>

            <!-- Seçili Addon'ların Detayı -->
            <div class="addon-price-breakdown ml-15 mb-15" *ngIf="selectedAddonCount > 0">
              <div *ngFor="let addon of selectedAddons | keyvalue" 
                   class="d-flex items-center justify-between text-13 text-light-1 py-5"
                   [class.d-none]="addon.value.isRequired">
                <span>• {{ addon.value.name }}</span>
                <span>{{ addon.value.price | currency:'TRY':'symbol':'1.0-0':'tr' }}</span>
              </div>
            </div>

            <div class="border-top-light pt-15">
              <div class="d-flex items-center justify-between mb-10">
                <div class="text-16 fw-600 text-dark-1">{{ getRoomNightText() }}</div>
                <div class="text-20 fw-700 text-dark-1">
                  {{ (currentTotalPrice > 0 ? currentTotalPrice : transactionSummary?.data?.balance?.value) |
                  currency:'TRY':'symbol':'1.0-0':'tr' }}
                </div>
              </div>
              <div class="text-12 text-light-1">Tüm Vergiler Dahil</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>